<template lang="pug">
    div
        regular-button(v-if="showProfileButton" @click="onOpen" :value="buttonLabel")
        modal(:name="`recipient-profile-${item._id}`" height="auto" :adaptive="true" :scrollable="true" classes="form-modal")
            .bg-gray-100(ref="formScroll")
                .p-6
                        template(v-if="sentToZup")
                            .text-lg.font-medium.mb-4 Данные отправлены в ЗУП
                            .text-sm.mb-2
                                span.font-medium Телефон:
                                span.ml-2 {{ displayPhone }}
                            .text-sm.mb-6
                                span.font-medium ИНН:
                                span.ml-2 {{ displayInn }}
                            regular-button(value="Закрыть" color="gray" @click="onClose")
                        template(v-else)
                            .text-lg.font-medium.mb-4 {{ profileTitle }} {{onFormatPhone(item)}}
                            .text-xs.text-gray-500.mb-4(v-if="canEditProfile && hasProfile") После сохранения признак «подтвержден» сбрасывается
                            .text-xs.text-gray-500.mb-4(v-else-if="canEditProfile") Анкета ещё не заполнена — можно внести данные за призёра

                            fieldset.border-0.p-0.m-0.min-w-0(:disabled="!canEditProfile")
                                .grid.grid-cols-2.gap-3.mb-4
                                    text-input(label="Фамилия" :maxlength="100" :value="form.lastname" @value="form.lastname = $event")
                                    text-input(label="Имя" :maxlength="100" :value="form.firstname" @value="form.firstname = $event")
                                    text-input(label="Отчество" :maxlength="100" :value="form.patronymic" @value="form.patronymic = $event")
                                    text-input(label="Телефон" :maxlength="15" :value="form.phone" @value="form.phone = $event")
                                    text-input(label="E-mail" :maxlength="100" :value="form.email" @value="form.email = $event")
                                    text-input(label="ИНН" :maxlength="12" :value="form.inn" @value="form.inn = $event")

                                .grid.grid-cols-2.gap-3.mb-4
                                    text-input(label="Индекс" :maxlength="6" :value="form.location.area_code" @value="form.location.area_code = $event")
                                    text-input(label="Город" :maxlength="100" :value="form.location.city" @value="form.location.city = $event")
                                    text-input(label="Улица" :maxlength="100" :value="form.location.street" @value="form.location.street = $event")
                                    text-input(label="Дом" :maxlength="20" :value="form.location.building" @value="form.location.building = $event")
                                    text-input(label="Корпус/строение" :maxlength="20" :value="form.location.house_body" @value="form.location.house_body = $event")
                                    text-input(label="Квартира" :maxlength="20" :value="form.location.apartment" @value="form.location.apartment = $event")

                                .grid.grid-cols-2.gap-3.mb-4
                                    text-input(label="Паспорт серия" :maxlength="4" :value="form.passport.series" @value="form.passport.series = $event")
                                    text-input(label="Паспорт номер" :maxlength="6" :value="form.passport.number" @value="form.passport.number = $event")
                                    text-input(label="Дата выдачи" inputType="date" :value="form.passport.issued_date" @value="form.passport.issued_date = $event")
                                    text-input(label="Кем выдан" :maxlength="200" :value="form.passport.issued_by" @value="form.passport.issued_by = $event")
                                    text-input(label="Код подразделения" :maxlength="7" :value="form.passport.subdivision_code" @value="form.passport.subdivision_code = $event")
                                    text-input(label="Адрес регистрации" :maxlength="300" :value="form.passport.registration_address" @value="form.passport.registration_address = $event")

                                ul.text-left.mb-4
                                    li.mb-3
                                        .text-sm.font-medium.mb-2 Фото паспорта главного разворота
                                        template(v-if="photoPreview || passportPhotoUrl")
                                            a.text-sm.underline.block.mb-2(v-if="photoIsPdf" :href="photoPreview || passportPhotoUrl" target="_blank") скачать PDF
                                            img.h-150.w-auto.cursor-pointer.mb-2(
                                                v-else
                                                :src="photoPreview || passportPhotoUrl"
                                                :crossorigin="remoteImage(photoPreview || passportPhotoUrl)"
                                                @click="onImg(photoPreview || passportPhotoUrl)")
                                        label.text-xs.underline.cursor-pointer(v-if="canEditProfile")
                                            | {{ form.passport.photo ? 'заменить файл' : 'загрузить jpg, png или pdf' }}
                                            input.hidden(type="file" accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf" @change="onUploadPhoto($event, 'photo')")
                                    li
                                        .text-sm.font-medium.mb-2 Фото паспорта прописки/регистрации
                                        template(v-if="registrationPreview || passportRegistrationUrl")
                                            a.text-sm.underline.block.mb-2(v-if="registrationIsPdf" :href="registrationPreview || passportRegistrationUrl" target="_blank") скачать PDF
                                            img.h-150.w-auto.cursor-pointer.mb-2(
                                                v-else
                                                :src="registrationPreview || passportRegistrationUrl"
                                                :crossorigin="remoteImage(registrationPreview || passportRegistrationUrl)"
                                                @click="onImg(registrationPreview || passportRegistrationUrl)")
                                        label.text-xs.underline.cursor-pointer(v-if="canEditProfile")
                                            | {{ form.passport.photo_registration ? 'заменить файл' : 'загрузить jpg, png или pdf' }}
                                            input.hidden(type="file" accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf" @change="onUploadPhoto($event, 'photo_registration')")

                                template(v-if="hasAdditional")
                                    .text-lg.mt-5.mb-3 Дополнительные данные:
                                    ul.text-left.mb-4
                                        li.flex.mb-2
                                            .text-sm.font-medium.mr-2 IP адрес:
                                            .text-sm {{ additional.ip }}
                                        li.flex.mb-2
                                            .text-sm.font-medium.mr-2 Браузер:
                                            .text-sm {{ additional.browser }} {{ additional.version }}
                                        li.flex.mb-2
                                            .text-sm.font-medium.mr-2 Операционная система:
                                            .text-sm {{ additional.os }}

                            .flex.items-center.gap-3.mt-2
                                regular-button(v-if="canEditProfile" :value="saveButtonLabel" :loading="isSaving || fileIsLoading" :isActive="isFormDirty && !isSaving && !fileIsLoading && !isConfirming" @click="onSave")
                                regular-button(v-if="showConfirm" value="Подтвердить" color="green" :loading="isConfirming" :isActive="!isConfirming && !isSaving" @click="onConfirm")
                                regular-button(value="Закрыть" color="gray" @click="onClose")
</template>

<script>
import TextInput from '@/components/common/forms/text-input';
import RegularButton from '@/components/common/buttons/regular-button';
import { BUTTONS_VALUES } from '@/configs/names';
import { ICONS } from '@/configs/icons';
import { RecipientsNameSpace, RecipientsActionTypes } from '@/store/recipients/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';
import { _openModal_, _closeModal_ } from '@/mixins/modals';
import { _onFileUpload_ } from '@/mixins/files';
import { onFormatPhone } from '@/helpers/format-phone';
import { notifyError } from '@/helpers/notifications';

const emptyForm = () => ({
    lastname: '',
    firstname: '',
    patronymic: '',
    phone: '',
    email: '',
    inn: '',
    location: {
        city: '',
        area_code: '',
        street: '',
        building: '',
        house_body: '',
        apartment: '',
    },
    passport: {
        series: '',
        number: '',
        issued_date: '',
        issued_by: '',
        subdivision_code: '',
        registration_address: '',
        photo: '',
        photo_registration: '',
    },
});

export default {
    name: "RecipientProfile",
    mixins: [_openModal_, _closeModal_, _onFileUpload_],
    components: {
        'text-input': TextInput,
        'regular-button': RegularButton,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            form: emptyForm(),
            formSnapshot: '',
            isSaving: false,
            isConfirming: false,
            fileIsLoading: false,
            uploadFiles: [],
            photoPreview: '',
            registrationPreview: '',
            photoIsPdf: false,
            registrationIsPdf: false,
        }
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        ICONS() {
            return ICONS
        },
        hasProfile() {
            return Boolean(this.item.profile && (this.item.profile._id || this.item.profile.id || this.item.profile.lastname))
        },
        sentToZup() {
            const profile = this.item.profile
            return Boolean(profile && typeof profile === 'object' && profile.sent_to_zup)
        },
        displayPhone() {
            const profile = this.item.profile || {}
            const phone = profile.phone || this.item.phone || ''
            if (!phone) {
                return 'не указан'
            }
            return onFormatPhone({ phone })
        },
        displayInn() {
            const profile = this.item.profile || {}
            return profile.inn || 'не указан'
        },
        userRole() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
        },
        canEditProfile() {
            return this.userRole === 1 || this.userRole === 2
        },
        isApproved() {
            const profile = this.item.profile
            return Boolean(profile && typeof profile === 'object' && profile.approved)
        },
        showConfirm() {
            return this.hasProfile && !this.isApproved && [1, 2, 3, 6].includes(this.userRole)
        },
        isFormDirty() {
            return JSON.stringify(this.form) !== this.formSnapshot
        },
        showProfileButton() {
            return this.canEditProfile || this.hasProfile
        },
        profileTitle() {
            if (!this.canEditProfile) {
                return 'Анкета'
            }
            return this.hasProfile ? 'Редактирование анкеты' : 'Заполнение анкеты'
        },
        buttonLabel() {
            return this.hasProfile ? this.BUTTONS_VALUES.data : 'заполнить'
        },
        PROFILE_DATA() {
            return this.item.profile || {}
        },
        additional() {
            return this.PROFILE_DATA.additional || {}
        },
        hasAdditional() {
            return Boolean(this.additional.ip || this.additional.browser || this.additional.os)
        },
        saveButtonLabel() {
            if (this.fileIsLoading) {
                return 'загрузка файла...'
            }
            return this.BUTTONS_VALUES.save
        },
        base_url() {
            return process.env.VUE_APP_BASE_URL
        },
        passportPhotoUrl() {
            return this.fileUrl(this.PROFILE_DATA.passport && this.PROFILE_DATA.passport.photo)
        },
        passportRegistrationUrl() {
            return this.fileUrl(this.PROFILE_DATA.passport && this.PROFILE_DATA.passport.photo_registration)
        },
    },
    methods: {
        toDateInput(value) {
            if (!value) {
                return ''
            }
            const date = new Date(value)
            if (Number.isNaN(date.getTime())) {
                return ''
            }
            const day = String(date.getUTCDate()).padStart(2, '0')
            const month = String(date.getUTCMonth() + 1).padStart(2, '0')
            const year = date.getUTCFullYear()
            return `${year}-${month}-${day}`
        },
        fillForm() {
            const profile = this.PROFILE_DATA
            const location = profile.location || {}
            const passport = profile.passport || {}
            this.form = {
                lastname: profile.lastname || '',
                firstname: profile.firstname || '',
                patronymic: profile.patronymic || '',
                phone: profile.phone || this.item.phone || '',
                email: profile.email || '',
                inn: profile.inn || '',
                location: {
                    city: location.city || '',
                    area_code: location.area_code || '',
                    street: location.street || '',
                    building: location.building || '',
                    house_body: location.house_body || '',
                    apartment: location.apartment || '',
                },
                passport: {
                    series: passport.series || '',
                    number: passport.number || '',
                    issued_date: this.toDateInput(passport.issued_date),
                    issued_by: passport.issued_by || '',
                    subdivision_code: passport.subdivision_code || '',
                    registration_address: passport.registration_address || '',
                    photo: this.fileId(passport.photo),
                    photo_registration: this.fileId(passport.photo_registration),
                },
            }
            this.formSnapshot = JSON.stringify(this.form)
            this.photoPreview = ''
            this.registrationPreview = ''
            this.photoIsPdf = this.isPdf(passport.photo)
            this.registrationIsPdf = this.isPdf(passport.photo_registration)
        },
        fileId(file) {
            if (!file) {
                return ''
            }
            if (typeof file === 'string') {
                return file
            }
            return file._id || file.id || ''
        },
        onOpen() {
            this.fillForm()
            this._openModal_({ name: `recipient-profile-${this.item._id}` })
        },
        isAllowedFile(file) {
            const subtype = ((file.type && file.type.split('/')[1]) || '').toLowerCase()
            const name = (file.name || '').toLowerCase()
            return ['png', 'jpg', 'jpeg', 'pdf'].includes(subtype) || name.endsWith('.pdf')
        },
        async onUploadPhoto(event, field) {
            const file = event.target.files && event.target.files[0]
            if (!file) {
                return
            }
            if (!this.isAllowedFile(file)) {
                notifyError({ title: 'Можно загрузить только jpg, png или pdf' })
                return
            }
            if (file.size > 10000000) {
                notifyError({ title: 'Файл не может быть больше 10mb' })
                return
            }
            this.fileIsLoading = true
            this.uploadFiles = event.target.files
            await this._onFileUpload_({ field: 'uploadFiles' })
            this.fileIsLoading = false
            const loaded = this._loadedFile_
            const id = loaded && (loaded._id || loaded.id)
            if (!id) {
                notifyError({ title: 'Не удалось загрузить файл' })
                return
            }
            this.form.passport[field] = id
            const preview = URL.createObjectURL(file)
            const isPdf = this.isPdf(file) || (file.name || '').toLowerCase().endsWith('.pdf')
            if (field === 'photo') {
                this.photoIsPdf = isPdf
                this.photoPreview = preview
            } else {
                this.registrationIsPdf = isPdf
                this.registrationPreview = preview
            }
            event.target.value = ''
        },
        modalScroll() {
            const inner = this.$refs.formScroll ? this.$refs.formScroll.scrollTop : 0
            const box = document.querySelector('.vm--modal.form-modal')
            return {
                inner,
                box: box ? box.scrollTop : 0,
            }
        },
        restoreModalScroll(position) {
            const apply = () => {
                if (this.$refs.formScroll) {
                    this.$refs.formScroll.scrollTop = position.inner
                }
                const box = document.querySelector('.vm--modal.form-modal')
                if (box) {
                    box.scrollTop = position.box
                }
            }
            this.$nextTick(() => {
                apply()
                requestAnimationFrame(apply)
            })
        },
        async onSave() {
            if (this.isSaving || this.fileIsLoading) {
                return
            }
            const scroll = this.modalScroll()
            this.isSaving = true
            try {
                if (this.hasProfile) {
                    const profileId = this.item.profile.id || this.item.profile._id
                    await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.EditRecipientProfile}`, {
                        id: profileId,
                        value: this.form,
                    })
                } else {
                    await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.AddRecipientProfile}`, {
                        value: {
                            ...this.form,
                            recipient: this.item._id,
                        },
                    })
                }
                this.formSnapshot = JSON.stringify(this.form)
            } finally {
                this.isSaving = false
                this.restoreModalScroll(scroll)
            }
        },
        onClose() {
            this._closeModal_({ name: `recipient-profile-${this.item._id}` })
        },
        async onConfirm() {
            if (this.isConfirming || this.isSaving || !this.showConfirm) {
                return
            }
            this.isConfirming = true
            try {
                await this.$store.dispatch(`${RecipientsNameSpace}/${RecipientsActionTypes.EditRecipient}`, {
                    id: this.item._id,
                    value: { approved: true },
                })
            } finally {
                this.isConfirming = false
            }
        },
        isPdf(file) {
            if (!file) {
                return false
            }
            const type = String(file.type || '').toLowerCase()
            const path = String(file.path || file.name || '').toLowerCase()
            return type.includes('pdf') || path.endsWith('.pdf')
        },
        remoteImage(url) {
            return url && /^https?:\/\//.test(url) ? 'use-credentials' : null
        },
        fileUrl(file) {
            if (!file || !file.path) {
                return ''
            }
            const relative = String(file.path).replace(/^\.\//, '').replace(/^uploads\//, '')
            return `${this.base_url}/uploads/${relative}`
        },
        onFormatPhone({phone}) {
            return onFormatPhone({phone})
        },
        onImg(url) {
            window.open(url, 'blank')
        }
    },
}
</script>
